module.exports = "/static-assets/_next/static/images/mailbox-c4049e1e191ae7a714426ba131d0b53b.png";